import { render, staticRenderFns } from "./suportBank.vue?vue&type=template&id=c838d340&scoped=true&"
import script from "./suportBank.vue?vue&type=script&lang=js&"
export * from "./suportBank.vue?vue&type=script&lang=js&"
import style0 from "./suportBank.vue?vue&type=style&index=0&lang=css&"
import style1 from "./suportBank.vue?vue&type=style&index=1&id=c838d340&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c838d340",
  null
  
)

export default component.exports